export const ACCENT = "#2563EB";
export const ACCENT_LIGHT = "#EFF6FF";
export const ACCENT_MID = "#DBEAFE";
